
import React from 'react';

import * as FormComponent from './form_components.jsx';

import {
  Mode
} from './common.jsx';
import Helpers from './components/helpers.jsx';

import Resolver from './component_resolver.jsx';
import { resolveComponentProps } from './form_viewer.jsx';

import merge from 'deepmerge';

export const NO_ANSWERS = {}

/*
 * Container the form content (draggable components in edit mode)
 */
export default class FormContent extends React.Component {
  constructor(props) {
      super(props);
      this.answerDependencies = {}
      this.closeTooltips = this.closeTooltips.bind(this);
  }

  render() {
      // N.B! theoretical support for multiple pages
      let formComponents = (this.props.form.hasOwnProperty('pages')) ? this.props.form.pages[0].components.map((c, i) => {
          return Resolver.createElement(c.type, resolveComponentProps(c, {...this.props, resolveRelatedAnswers: this.resolveRelatedAnswers}, {sortOrder: i}));
      }) : '';

      this.headerContent = FormComponent.Header.defaultContent(this.props.language);

      if (this.props.form.translations) {
          this.headerContent.translations = this.props.form.translations;
      }

      const { renderHeader = true } = this.props;
      const paged = this.props.form.paged;

      return (
          <div ref="root" className="components">
              {renderHeader && (!paged || this.props.mode === Mode.EDIT) && <FormComponent.Header
                  language={this.props.language}
                  key="header"
                  content={this.headerContent}
                  selectCallback={this.props.selectComponentCallback}
                  selectedId={this.props.selectedFormComponentId}
                  mode={this.props.mode}
                  viewMode={this.props.viewMode}/> }
              <div ref="page" className="page">
                  {formComponents}
              </div>
              {this.props.mode == Mode.EDIT && !this.props.hideDropArea && !paged  ? <Helpers.DropArea /> : null}
          </div>
      );
  }

  componentDidMount() {
      if (this.props.mode == Mode.EDIT) {
          this.props.selectComponentCallback(this.headerContent);
      } else if (this.props.mode != Mode.FILL) {
          var form = jQuery(this.refs.root).closest('form');
          if (typeof ame !== 'undefined') {
              // ame.convertFormToPrintable(form);
          }
      }
      // post a message to webview to let it know when the component has mounted and the loading of it has been finished
      if (window.ReactNativeWebView) { 
          window.ReactNativeWebView.postMessage(JSON.stringify({ loading: false }));
      }
      // Init tooltips
      this.initTooltips();
  }

  componentDidUpdate() {
      this.initTooltips();
  }

  initTooltips() {
      jQuery(this.refs.page).find('span.help').tooltip({
          trigger: 'manual',  
          container: 'body'
      }).off('click').on('click', (e) => {
          jQuery(e.currentTarget).tooltip('toggle');
          e.stopPropagation();
          return false;
      });

      // Close tooltips on a click outside them.
      jQuery('body').off('mousedown', this.closeTooltips).on('mousedown', this.closeTooltips);
  }

  closeTooltips(e) {
      if (!jQuery(e.target).is('span.help') && jQuery(e.target).parents('.tooltip.in').length === 0) {
          jQuery(this.refs.page).find('.tooltip').not('.sdgs .tooltip').not('.warning-tooltip + .tooltip').tooltip('destroy');
      }
  }
  
  
  /* 
    Resolves a subset of answers related to the given component
    A component implements a static resolveRelatedAnswerNamesOrIds which returns the name or id of the fields
    The return value is stored as dependencies to improve performance as this gets called for every answer update
  */
  resolveRelatedAnswers = (ComponentClass, content, props) => {
    const { answers, repeatedFieldScope } = props;

    if (!content || !answers) return NO_ANSWERS;
    if (Object.keys(answers).length == 0) return NO_ANSWERS;

    const dependencyName = (repeatedFieldScope || '') + content.id
    if (!this.answerDependencies[dependencyName]) {
      // Get the names or ids. Resolve names for ids.
      const deps = (ComponentClass.resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope) || [])
        .map((c, idx, x) => {
          const id = (c.match(/id-.+?(?=\])/) || [])[0];
          const component = id ? props.findComponentsCallback({id: id})[0] : c;
          if (!component) {
            // This could happen if there's a broken dependency, i.e. component has been deleted.
            return null;
          }
          return id ? c.replace(id, component.name) : c;
        }).filter(Boolean); // Remove the nulls, see above

      // Remove duplicates to prevent array answers having duplicate values
      this.answerDependencies[dependencyName] = [...new Set(deps)];
    }

    let retAnswers = {};

    (this.answerDependencies[dependencyName] || []).forEach(namePath => { 
      const namePaths = namePath.split(/[\[\]]+/).filter((s) => ([''].indexOf(s) == -1));
      let answerIterator = null;
      let answerPrefilled = null;
      // Read the value at the end of path
      namePaths.forEach((k, idx) => {
        // First read prefill value for namePath
        answerPrefilled = answerIterator ? answerIterator[`${k}_readOnly`] : answers[`${k}_readOnly`];
        answerIterator = answerIterator ? answerIterator[k] : answers[k];
      });

      // If answer was found, add it
      if (answerIterator !== void 0) {
        let retAnswer = {};
        namePaths.reduce(function(o, s, idx) { return o[s] = idx == namePaths.length - 1 ? answerIterator : {} }, retAnswer)
        namePaths.reduce(function (o, s, idx) {
          if (idx == namePaths.length - 1) {
            o[`${s}_readOnly`] = answerPrefilled;
          }
          return o[s];
        }, retAnswer);

        // Do a deep merge, as we are only setting the relevant properties.
        retAnswers = merge(retAnswers, retAnswer)
      }

    });
    
    return retAnswers
  }

}
